import {dataTestId, useBreakPoints} from '@hconnect/uikit'
import {CheckOutlined as CheckOutlinedIcon} from '@mui/icons-material'
import {LoadingButton, LoadingButtonProps} from '@mui/lab'
import {Stack} from '@mui/material'
import {useEffect, useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'

const useSmallScreen = () => {
  const screenSizes = useBreakPoints()
  const isMobile = ['xs', 'sm'].includes(screenSizes)

  return {isMobile}
}

type ItemDetailsLayoutHeaderSaveBtnProps = {
  onClick?: () => void
  disabled?: boolean
  buttonProps?: Omit<LoadingButtonProps, 'variant' | 'startIcon' | 'onClick' | 'disabled'>
}

export const ItemDetailsLayoutHeaderSaveBtn: React.FC<ItemDetailsLayoutHeaderSaveBtnProps> = ({
  onClick,
  disabled,
  buttonProps
}) => {
  const {t} = useTranslation()
  const {isMobile} = useSmallScreen()
  const saveBtnAnchorRef = useRef<HTMLDivElement>(null)
  const saveBtnRef = useRef<HTMLButtonElement>(null)
  const [isSaveBtnVisible, setIsSaveBtnVisible] = useState<boolean>(true)

  useEffect(() => {
    const isElementInViewport = (el: Element | null): boolean => {
      if (!el) return false
      const rect = el.getBoundingClientRect()
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }

    const handleScroll = () => {
      if (saveBtnAnchorRef.current) {
        const isVisible = isElementInViewport(saveBtnAnchorRef.current)

        if (isVisible) {
          if (saveBtnRef.current) {
            setIsSaveBtnVisible(true)
          }
        } else {
          setIsSaveBtnVisible(false)
        }
      }
    }

    window.addEventListener('scroll', handleScroll, {passive: true})
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <Stack flexDirection={'row'}>
      <div ref={saveBtnAnchorRef} />

      <LoadingButton
        ref={saveBtnRef}
        {...dataTestId('plant-structure-details-save-button')}
        variant="contained"
        sx={
          !isSaveBtnVisible && !isMobile
            ? {
                position: 'fixed',
                top: '70px',
                right: '55px',
                zIndex: 3
              }
            : {}
        }
        startIcon={<CheckOutlinedIcon />}
        onClick={onClick}
        disabled={disabled}
        {...buttonProps}
      >
        {t('plantSetup.action.save')}
      </LoadingButton>
    </Stack>
  )
}
